module.exports = __webpack_public_path__ + "static/img/icon_payment_complete_bg.9d79fcf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/icon_payment_complete_bg.svg
// module id = uqP2
// module chunks = 10